(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------------------------------------------------------------------
     Utilities
     ------------------------------------------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function trapOpen(panelSelector) {
    var el = qs(panelSelector);
    if (el) {
      // Entrance animations only play on open, not when a section re-render swaps the drawer
      if (!el.hasAttribute('open')) {
        el.setAttribute('data-animate-in', '');
        window.clearTimeout(el._animateInTimer);
        el._animateInTimer = window.setTimeout(function () {
          var live = qs(panelSelector);
          if (live) live.removeAttribute('data-animate-in');
        }, 1400);
      }
      el.setAttribute('open', '');
    }
    document.body.style.overflow = 'hidden';
  }
  function trapClose(panelSelector) {
    var el = qs(panelSelector);
    if (el) el.removeAttribute('open');
    document.body.style.overflow = '';
  }

  /* ---------------------------------------------------------------------
     Mobile nav + cart drawer open/close (shared behaviour)
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      trapOpen('#' + opener.getAttribute('data-open'));
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      trapClose('#' + closer.getAttribute('data-close'));
      return;
    }
    var backdrop = e.target.closest('[data-drawer-backdrop]');
    if (backdrop) {
      trapClose('#' + backdrop.closest('[id]').id);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      qsa('[open]:not(dialog):not(details)').forEach(function (el) { el.removeAttribute('open'); });
      document.body.style.overflow = '';
    }
  });

  /* ---------------------------------------------------------------------
     Quantity selectors — used on product page and cart lines
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-change]');
    if (!btn) return;
    var wrapper = btn.closest('[data-quantity-selector]');
    var input = qs('input[type="number"]', wrapper);
    var step = parseInt(input.step || '1', 10);
    var min = parseInt(input.min || '1', 10);
    var value = parseInt(input.value || '1', 10);
    value = btn.getAttribute('data-quantity-change') === 'plus' ? value + step : Math.max(min, value - step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------
     Cart AJAX helpers.
     Section ids are read live from the DOM (data-section-id mirrors the
     runtime {{ section.id }}, which differs between static sections and
     sections inside JSON templates) rather than hardcoded, and refreshed
     by re-requesting the current URL so only sections present on this
     route are asked for.
     ------------------------------------------------------------------- */
  function getCartSectionElements() { return qsa('[data-cart-section]'); }

  // Markup for an icon from the inline sprite (snippets/icon-sprite.liquid).
  function iconSvg(name, extraClass) {
    return '<svg class="icon' + (extraClass ? ' ' + extraClass : '') + '" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><use class="icon__line" href="#gfi-' + name + '"></use></svg>';
  }

  function renderSections(sectionsHtml) {
    getCartSectionElements().forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (!sectionsHtml[id]) return;
      var doc = new DOMParser().parseFromString(sectionsHtml[id], 'text/html');
      var fresh = doc.querySelector('[data-section-id="' + id.replace(/"/g, '\\"') + '"]');
      if (!fresh) return;
      if (el.hasAttribute('open')) fresh.setAttribute('open', '');
      el.replaceWith(fresh);
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function fetchCartSections() {
    var ids = getCartSectionElements().map(function (el) { return el.getAttribute('data-section-id'); });
    if (!ids.length) return Promise.resolve();
    var url = window.location.pathname + window.location.search;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.json(); })
      .then(renderSections);
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { var err = new Error(data.description || 'Cart error'); err.data = data; throw err; }
        return data;
      });
    });
  }

  // JSON variant of addToCart for several lines at once ([{ id, quantity, properties? }]).
  function addItemsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { var err = new Error(data.description || 'Cart error'); err.data = data; throw err; }
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) { return r.json(); });
  }

  /* Add-to-cart forms (product page + quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = qs('[type="submit"]', form);
    var formData = new FormData(form);
    // Pack selector (main-product) can expand one pack into one line per design.
    var items = typeof form._gfCartItems === 'function' ? form._gfCartItems() : null;
    if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.disabled = true; }

    (items && items.length ? addItemsToCart(items) : addToCart(formData))
      .then(function () { return fetchCartSections(); })
      .then(function () {
        var cartType = document.body.getAttribute('data-cart-type');
        if (cartType === 'drawer') {
          trapOpen('#cart-drawer');
        } else if (!/\/cart\/?$/.test(window.location.pathname)) {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        var errorEl = qs('[data-form-error]', form);
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      })
      .finally(function () {
        if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.disabled = false; }
      });
  });

  /* ---------------------------------------------------------------------
     Variant picker (product page).
     Variant data is pre-rendered by Liquid (money strings, image urls) so
     no client-side money formatting is needed.
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-option-value]');
    if (!swatch) return;
    var group = swatch.closest('[data-option-index]');
    qsa('[data-option-value]', group).forEach(function (b) { b.classList.remove('is-selected'); });
    swatch.classList.add('is-selected');

    var form = swatch.closest('[data-product-form]');
    var root = swatch.closest('[data-product-root]') || document;
    var groups = qsa('[data-option-index]', form).sort(function (a, b) {
      return parseInt(a.getAttribute('data-option-index'), 10) - parseInt(b.getAttribute('data-option-index'), 10);
    });
    var selected = groups.map(function (g) {
      var active = qs('.is-selected', g);
      return active ? active.getAttribute('data-option-value') : null;
    });

    var dataEl = qs('[data-product-variants]', form);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var match = variants.filter(function (v) { return v.available; }).find(function (v) {
      return [v.option1, v.option2, v.option3].slice(0, selected.length).every(function (opt, i) { return opt === selected[i]; });
    }) || variants.find(function (v) {
      return [v.option1, v.option2, v.option3].slice(0, selected.length).every(function (opt, i) { return opt === selected[i]; });
    });

    var select = qs('[data-variant-select]', form);
    var addBtn = qs('[data-add-to-cart-submit]', form);
    var label = addBtn && qs('[data-add-to-cart-label]', addBtn);
    var priceWrap = qs('[data-product-price]', root);
    var mainImg = qs('[data-gallery-main]', root);

    if (select && match) select.value = match.id;
    if (addBtn) addBtn.disabled = !(match && match.available);
    if (label) label.textContent = match && match.available ? label.getAttribute('data-available-text') || label.textContent : label.getAttribute('data-unavailable-text') || 'Sold out';
    if (priceWrap && match) {
      priceWrap.innerHTML = '<span class="price-wrap"><span class="price">' + match.price_html + '</span>' +
        (match.compare_at_price_html ? '<span class="text-strike label-sm">' + match.compare_at_price_html + '</span>' : '') +
        '</span>';
    }
    if (match && match.featured_image) {
      var pg = qs('[data-pg]', root);
      if (pg && pg._pg) pg._pg.goToSrc(match.featured_image);
      else if (mainImg) mainImg.src = match.featured_image;
    }
  });

  /* Quick add buttons on product cards (collection/home grids) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-quick-add');
    if (!variantId) return;
    if (btn.classList.contains('is-loading')) return;
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-loading');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    addToCart(body)
      .then(function () { return fetchCartSections(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        window.setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        var cartType = document.body.getAttribute('data-cart-type');
        if (cartType === 'drawer') window.setTimeout(function () { trapOpen('#cart-drawer'); }, 450);
      })
      .catch(function (err) {
        console.error(err);
        btn.classList.add('is-error');
        window.setTimeout(function () { btn.classList.remove('is-error'); }, 1200);
      })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* Cart line quantity + remove (cart page and drawer) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-quantity]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-cart-line-quantity'), 10);
    var row = input.closest('[data-cart-line]');
    if (row) row.classList.add('is-loading');
    changeLine(line, parseInt(input.value, 10)).then(fetchCartSections);
  });

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-line-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var line = parseInt(removeBtn.getAttribute('data-cart-line-remove'), 10);
    var row = removeBtn.closest('[data-cart-line]');
    if (row) row.classList.add('is-loading');
    changeLine(line, 0).then(fetchCartSections);
  });

  /* Discount codes (cart page summary + cart drawer).
     The Ajax Cart API replaces the whole code list, so we always send the
     codes already applied plus/minus the one being changed. */
  function setDiscountCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (res) {
      if (!res.ok) throw new Error('Discount error');
      return res.json();
    });
  }
  function renderDiscountCodes() {
    var lists = qsa('[data-discount-codes]');
    if (!lists.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        lists.forEach(function (list) {
          list.innerHTML = '';
          codes.forEach(function (c) {
            var chip = document.createElement('li');
            chip.className = 'cart-discount__code' + (c.applicable ? '' : ' is-invalid');
            chip.setAttribute('data-discount-code', c.code);
            chip.setAttribute('data-applicable', String(!!c.applicable));
            chip.innerHTML = iconSvg('sell', 'icon--sm') + '<span class="cart-discount__code-text"></span>' +
              '<button type="button" class="cart-discount__remove"><span class="icon icon--sm" aria-hidden="true">close</span></button>';
            chip.querySelector('.cart-discount__code-text').textContent = c.code;
            var btn = chip.querySelector('button');
            btn.setAttribute('data-discount-remove', c.code);
            btn.setAttribute('aria-label', list.getAttribute('data-label-remove') + ' ' + c.code);
            list.appendChild(chip);
            if (!c.applicable) {
              var msg = document.createElement('li');
              msg.className = 'cart-discount__invalid label-sm';
              msg.textContent = list.getAttribute('data-msg-invalid').replace('__CODE__', c.code);
              list.appendChild(msg);
            }
          });
          list.hidden = codes.length === 0;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', renderDiscountCodes);
  renderDiscountCodes();

  function appliedCodes(scope) {
    return qsa('[data-discount-code]', scope)
      .filter(function (el) { return el.getAttribute('data-applicable') === 'true'; })
      .map(function (el) { return el.getAttribute('data-discount-code'); });
  }
  function showDiscountError(scope) {
    var errorEl = qs('[data-discount-error]', scope);
    if (!errorEl) return;
    errorEl.textContent = errorEl.getAttribute('data-msg-failed');
    errorEl.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var scope = form.closest('[data-cart-discount]');
    var input = qs('input[name="discount"]', form);
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    var codes = appliedCodes(scope).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    codes.push(code);
    var btn = qs('[type="submit"]', form);
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    setDiscountCodes(codes)
      .then(fetchCartSections)
      .catch(function () {
        showDiscountError(scope);
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
  });

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-discount-remove]');
    if (!removeBtn) return;
    var scope = removeBtn.closest('[data-cart-discount]');
    var code = removeBtn.getAttribute('data-discount-remove');
    var codes = appliedCodes(scope).filter(function (c) { return c !== code; });
    removeBtn.closest('[data-discount-code]').classList.add('is-loading');
    setDiscountCodes(codes)
      .then(fetchCartSections)
      .catch(function () { showDiscountError(scope); });
  });

  /* Gift note toggle */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-gift-note-toggle]');
    if (!toggle) return;
    var body = qs('[data-gift-note-body]');
    if (!body) return;
    var isHidden = body.hidden;
    body.hidden = !isHidden;
    toggle.setAttribute('aria-expanded', String(isHidden));
  });
  document.addEventListener('change', function (e) {
    var textarea = e.target.closest('[data-gift-note-input]');
    if (!textarea) return;
    updateCartAttributes({ 'Gift Note': textarea.value });
  });

  /* ---------------------------------------------------------------------
     Wishlist (client-side, localStorage).
     gf_wishlist = product ids (strings), gf_wishlist_handles = { id: handle }.
     Hearts: [data-wishlist-toggle="<id>"][data-wishlist-handle]. Counters:
     [data-wishlist-count] (number) and [data-wishlist-count-text] (label).
     Drawer: snippets/wishlist-drawer.liquid, opened by [data-wishlist-open];
     items are fetched from /products/<handle>.js. Heart burst and the heart
     that flies to the header use the Web Animations API (no library).
     ------------------------------------------------------------------- */
  var WISHLIST_KEY = 'gf_wishlist';
  var WISHLIST_HANDLES_KEY = 'gf_wishlist_handles';
  var wlReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wlCountStrings = null;
  var wlProductCache = {};
  var wlRenderToken = 0;

  function wlReadJSON(key, fallback) {
    try {
      var value = JSON.parse(localStorage.getItem(key));
      return value == null ? fallback : value;
    } catch (e) { return fallback; }
  }
  function wlWriteJSON(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function getWishlist() {
    var list = wlReadJSON(WISHLIST_KEY, []);
    return Array.isArray(list) ? list.map(String) : [];
  }
  function setWishlist(list) { wlWriteJSON(WISHLIST_KEY, list); }
  function getWishlistHandles() {
    var handles = wlReadJSON(WISHLIST_HANDLES_KEY, {});
    return handles && typeof handles === 'object' ? handles : {};
  }

  function wlDrawer() { return qs('[data-wishlist-drawer]'); }
  function wlText(name) {
    var drawer = wlDrawer();
    return drawer ? drawer.getAttribute('data-text-' + name) || '' : '';
  }
  function wlRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function wlEscape(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function wlCountLabel(n) {
    if (!wlCountStrings) {
      var el = qs('[data-wishlist-count-strings]');
      try { wlCountStrings = el ? JSON.parse(el.textContent) : {}; } catch (e) { wlCountStrings = {}; }
    }
    return wlCountStrings[String(Math.min(n, 50))] || String(n);
  }

  function paintWishlistButtons() {
    var list = getWishlist();
    var n = list.length;
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', String(on));
      var label = wlText(on ? 'remove-label' : 'add-label');
      if (label) btn.setAttribute('aria-label', label);
      var icon = qs('.icon', btn);
      if (icon) icon.classList.toggle('icon--filled', on);
    });
    qsa('[data-wishlist-count-num]').forEach(function (el) { el.textContent = String(n); });
    qsa('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
    qsa('[data-wishlist-count-text]').forEach(function (el) { el.textContent = wlCountLabel(n); });
  }

  function wlVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  // Little hearts bursting out of the button
  function wishlistBurst(btn) {
    if (wlReducedMotion || !btn.animate) return;
    var r = btn.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    for (var i = 0; i < 9; i++) {
      var p = document.createElement('span');
      p.className = 'wishlist-particle';
      p.textContent = '♥';
      p.style.left = cx + 'px';
      p.style.top = cy + 'px';
      document.body.appendChild(p);
      var angle = (Math.PI * 2 * i) / 9 + Math.random() * 0.5;
      var dist = 26 + Math.random() * 26;
      var anim = p.animate([
        { transform: 'translate(-50%, -50%) scale(0.3)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + (Math.cos(angle) * dist).toFixed(1) + 'px), calc(-50% + ' + (Math.sin(angle) * dist).toFixed(1) + 'px)) scale(' + (0.6 + Math.random() * 0.7).toFixed(2) + ') rotate(' + Math.round(Math.random() * 70 - 35) + 'deg)', opacity: 0 }
      ], { duration: 650 + Math.random() * 300, easing: 'cubic-bezier(.2,.8,.2,1)' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(p);
    }
    btn.animate([
      { transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(0.88)' }, { transform: 'scale(1)' }
    ], { duration: 520, easing: 'ease-out' });
  }

  // A heart flies from the button to the header wishlist icon, which then bumps
  function wishlistFly(btn) {
    var target = qs('.site-header__wishlist');
    if (!wlVisible(target)) target = qs('.site-header__menu-toggle');
    if (wlReducedMotion || !btn.animate || !wlVisible(target)) return;
    var from = btn.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    var sx = from.left + from.width / 2;
    var sy = from.top + from.height / 2;
    var dx = to.left + to.width / 2 - sx;
    var dy = to.top + to.height / 2 - sy;
    var flyer = document.createElement('span');
    flyer.className = 'wishlist-flyer';
    flyer.textContent = '♥';
    flyer.style.left = sx + 'px';
    flyer.style.top = sy + 'px';
    document.body.appendChild(flyer);
    var anim = flyer.animate([
      { transform: 'translate(-50%, -50%) scale(0.6)', opacity: 0 },
      { transform: 'translate(calc(-50% + ' + (dx * 0.35).toFixed(1) + 'px), calc(-50% + ' + (dy * 0.35 - 90).toFixed(1) + 'px)) scale(1.5) rotate(-12deg)', opacity: 1, offset: 0.35 },
      { transform: 'translate(calc(-50% + ' + dx.toFixed(1) + 'px), calc(-50% + ' + dy.toFixed(1) + 'px)) scale(0.4) rotate(8deg)', opacity: 0.9 }
    ], { duration: 850, easing: 'cubic-bezier(.45,.05,.3,1)' });
    anim.onfinish = function () {
      flyer.remove();
      target.animate([
        { transform: 'scale(1)' }, { transform: 'scale(1.3) rotate(-8deg)' }, { transform: 'scale(0.92) rotate(4deg)' }, { transform: 'scale(1)' }
      ], { duration: 550, easing: 'ease-out' });
      qsa('[data-wishlist-count]', target).forEach(function (bubble) {
        bubble.animate([{ transform: 'scale(0.4)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'cubic-bezier(.3,1.6,.5,1)' });
      });
    };
  }

  function toggleWishlist(btn) {
    var id = btn.getAttribute('data-wishlist-toggle');
    var handle = btn.getAttribute('data-wishlist-handle');
    var list = getWishlist();
    var handles = getWishlistHandles();
    var idx = list.indexOf(id);
    var adding = idx === -1;
    if (adding) {
      list.push(id);
      if (handle) handles[id] = handle;
    } else {
      list.splice(idx, 1);
      delete handles[id];
    }
    setWishlist(list);
    wlWriteJSON(WISHLIST_HANDLES_KEY, handles);
    paintWishlistButtons();
    if (adding) {
      wishlistBurst(btn);
      wishlistFly(btn);
    }
    var drawer = wlDrawer();
    if (drawer && drawer.hasAttribute('open')) renderWishlist();
  }

  function wlFirstAvailable(product) {
    return (product.variants || []).filter(function (v) { return v.available; })[0] || null;
  }

  function wlFetchProduct(handle) {
    if (!wlProductCache[handle]) {
      wlProductCache[handle] = fetch(wlRoot() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        });
      wlProductCache[handle].catch(function () { delete wlProductCache[handle]; });
    }
    return wlProductCache[handle];
  }

  // Older saves only have ids: look their handles up once
  function wlResolveHandles(list) {
    var handles = getWishlistHandles();
    var missing = list.filter(function (id) { return !handles[id]; });
    if (!missing.length) return Promise.resolve(handles);
    return fetch(wlRoot() + 'products.json?limit=250')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        (data.products || []).forEach(function (p) {
          if (missing.indexOf(String(p.id)) !== -1) handles[String(p.id)] = p.handle;
        });
        wlWriteJSON(WISHLIST_HANDLES_KEY, handles);
        return handles;
      })
      .catch(function () { return handles; });
  }

  function wlItemHtml(row, index) {
    var p = row.product;
    var variant = wlFirstAvailable(p);
    var format = wlDrawer().getAttribute('data-money-format');
    var price = variant ? variant.price : p.price;
    var compare = variant ? variant.compare_at_price : p.compare_at_price;
    var url = wlRoot() + 'products/' + p.handle;
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=240' : '';

    return '<li class="wishlist-item" data-wishlist-item="' + wlEscape(row.id) + '" style="--i:' + Math.min(index, 8) + ';">' +
      '<a class="wishlist-item__media" href="' + wlEscape(url) + '">' +
        (img ? '<img src="' + wlEscape(img) + '" alt="" width="96" height="120" loading="lazy">' : '') +
      '</a>' +
      '<div class="wishlist-item__info">' +
        '<a class="wishlist-item__title" href="' + wlEscape(url) + '">' + wlEscape(p.title) + '</a>' +
        '<p class="wishlist-item__price"><span>' + formatMoney(price, format) + '</span>' +
          (compare && compare > price ? '<s>' + formatMoney(compare, format) + '</s>' : '') +
        '</p>' +
        (variant
          ? '<button type="button" class="wishlist-item__add" data-wishlist-add="' + variant.id + '">' +
              '<span class="icon icon--sm" aria-hidden="true">add_shopping_cart</span>' +
              '<span data-wishlist-add-label>' + wlEscape(wlText('add')) + '</span>' +
            '</button>'
          : '<span class="wishlist-item__sold-out">' + wlEscape(wlText('sold-out')) + '</span>') +
      '</div>' +
      '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + wlEscape(row.id) + '" aria-label="' + wlEscape(wlText('remove')) + '">' +
        '<span class="icon icon--sm" aria-hidden="true">close</span>' +
      '</button>' +
    '</li>';
  }

  function renderWishlist() {
    var drawer = wlDrawer();
    if (!drawer) return;
    var listEl = qs('[data-wishlist-items]', drawer);
    var empty = qs('[data-wishlist-empty]', drawer);
    var footer = qs('[data-wishlist-footer]', drawer);
    var loading = qs('[data-wishlist-loading]', drawer);
    var list = getWishlist().slice().reverse();   // newest first
    var token = ++wlRenderToken;

    paintWishlistButtons();
    if (!list.length) {
      listEl.innerHTML = '';
      loading.hidden = true;
      footer.hidden = true;
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    if (!listEl.children.length) loading.hidden = false;

    wlResolveHandles(list)
      .then(function (handles) {
        return Promise.all(list.map(function (id) {
          if (!handles[id]) return { id: id, product: null };
          return wlFetchProduct(handles[id]).then(
            function (product) { return { id: id, product: product }; },
            function () { return { id: id, product: null }; }
          );
        }));
      })
      .then(function (rows) {
        if (token !== wlRenderToken) return;
        loading.hidden = true;
        // Forget products that no longer exist on the store
        var gone = rows.filter(function (r) { return !r.product; }).map(function (r) { return r.id; });
        if (gone.length) {
          setWishlist(getWishlist().filter(function (id) { return gone.indexOf(id) === -1; }));
          paintWishlistButtons();
        }
        rows = rows.filter(function (r) { return r.product; });
        listEl.innerHTML = rows.map(wlItemHtml).join('');
        empty.hidden = rows.length > 0;
        footer.hidden = !rows.some(function (r) { return wlFirstAvailable(r.product); });
      });
  }

  function wlSetAddState(btn, state) {
    var label = qs('[data-wishlist-add-label]', btn);
    btn.classList.remove('is-loading', 'is-added', 'is-error');
    btn.disabled = state === 'adding';
    if (state === 'adding') { btn.classList.add('is-loading'); label.textContent = wlText('adding'); return; }
    if (state === 'added') { btn.classList.add('is-added'); label.textContent = wlText('added'); }
    if (state === 'error') { btn.classList.add('is-error'); label.textContent = wlText('error'); }
    window.clearTimeout(btn._wlTimer);
    btn._wlTimer = window.setTimeout(function () {
      btn.classList.remove('is-added', 'is-error');
      label.textContent = wlText('add');
    }, state === 'error' ? 3500 : 2200);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      toggleWishlist(toggle);
      return;
    }

    var opener = e.target.closest('[data-wishlist-open]');
    if (opener) {
      e.preventDefault();
      var nav = qs('#mobile-nav');
      if (nav && nav.hasAttribute('open')) nav.removeAttribute('open');
      trapOpen('#wishlist-drawer');
      renderWishlist();
      return;
    }

    var remove = e.target.closest('[data-wishlist-remove]');
    if (remove) {
      var id = remove.getAttribute('data-wishlist-remove');
      var item = remove.closest('[data-wishlist-item]');
      setWishlist(getWishlist().filter(function (x) { return x !== id; }));
      var handles = getWishlistHandles();
      delete handles[id];
      wlWriteJSON(WISHLIST_HANDLES_KEY, handles);
      paintWishlistButtons();
      if (item && !wlReducedMotion) {
        item.style.height = item.offsetHeight + 'px';
        item.classList.add('is-removing');
        window.setTimeout(function () { item.remove(); renderWishlist(); }, 420);
      } else {
        renderWishlist();
      }
      return;
    }

    var add = e.target.closest('[data-wishlist-add]');
    if (add) {
      var formData = new FormData();
      formData.append('id', add.getAttribute('data-wishlist-add'));
      formData.append('quantity', '1');
      wlSetAddState(add, 'adding');
      addToCart(formData)
        .then(function () { return fetchCartSections(); })
        .then(function () { wlSetAddState(add, 'added'); })
        .catch(function () { wlSetAddState(add, 'error'); });
      return;
    }

    var addAll = e.target.closest('[data-wishlist-add-all]');
    if (addAll) {
      var items = qsa('[data-wishlist-add]', wlDrawer()).map(function (b) {
        return { id: Number(b.getAttribute('data-wishlist-add')), quantity: 1 };
      });
      if (!items.length) return;
      addAll.classList.add('is-loading');
      addAll.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { if (!res.ok) throw new Error('Cart error'); return fetchCartSections(); })
        .then(function () {
          trapClose('#wishlist-drawer');
          if (document.body.getAttribute('data-cart-type') === 'drawer') {
            trapOpen('#cart-drawer');
          } else {
            window.location.href = wlRoot() + 'cart';
          }
        })
        .catch(function () {
          qsa('[data-wishlist-add]', wlDrawer()).forEach(function (b) { wlSetAddState(b, 'error'); });
        })
        .finally(function () {
          addAll.classList.remove('is-loading');
          addAll.disabled = false;
        });
    }
  });

  // The header is re-rendered after cart changes: repaint its counter
  document.addEventListener('cart:updated', paintWishlistButtons);
  // Keep tabs in sync
  window.addEventListener('storage', function (e) {
    if (e.key !== WISHLIST_KEY) return;
    paintWishlistButtons();
    var drawer = wlDrawer();
    if (drawer && drawer.hasAttribute('open')) renderWishlist();
  });


  /* ---------------------------------------------------------------------
     Cash-on-delivery order form (product page).

     The form reads the live selection from the neighbouring
     [data-product-form] at submit time, so the swatches and quantity
     selector already on the page stay the single source of truth. On a
     COD-only page those blocks may be gone, and the snippet renders
     replacements against the same contract — handled here identically.

     Submitting POSTs JSON to the endpoint configured on the block; no
     Shopify order is created. The body is sent as text/plain so the
     request stays a "simple" one and never triggers a CORS preflight,
     which is what makes plain Google Apps Script endpoints work. For
     endpoints that return no CORS headers at all, the block can opt into
     'no-cors': the browser then hides the reply from us entirely, so the
     submission is reported as successful once it has been dispatched.
     ------------------------------------------------------------------- */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    function withDelimiters(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      switch (name) {
        case 'amount': return withDelimiters(2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
        default: return match;
      }
    });
  }

  function codSelection(root) {
    var productForm = qs('[data-product-form]', root);
    if (!productForm) return null;
    var dataEl = qs('[data-product-variants]', productForm);
    var select = qs('[data-variant-select]', productForm);
    if (!dataEl || !select) return null;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var id = parseInt(select.value, 10);
    var variant = variants.filter(function (v) { return v.id === id; })[0];
    if (!variant) return null;

    var qtyInput = qs('[data-quantity-selector] input[type="number"]', root);
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    return { variant: variant, quantity: quantity };
  }

  /* Promo codes are the merchant's own list from the block settings, not
     Shopify discounts — Liquid cannot read those and this form never
     reaches Shopify's checkout. A rule is `CODE | 10%` or `CODE | 50`
     (fixed amount in the store's currency), with an optional minimum
     order amount. Both the code and the discount it produced go out in
     the payload so the endpoint can re-check them server side. */
  function parsePromoRule(rule) {
    var value = String(rule.value || '').trim();
    var amount = parseFloat(value.replace(/[^0-9.,]/g, '').replace(',', '.'));
    if (!amount || amount <= 0) return null;
    var percent = value.indexOf('%') !== -1;
    var min = parseFloat(String(rule.min || '').replace(/[^0-9.,]/g, '').replace(',', '.'));
    return {
      code: String(rule.code || '').trim(),
      rule: value,
      percent: percent,
      amount: percent ? amount : Math.round(amount * 100),
      min: min > 0 ? Math.round(min * 100) : 0
    };
  }

  function findPromoRule(form, code) {
    var el = qs('[data-cod-promo-codes]', form);
    if (!el || !code) return null;
    var rules;
    try { rules = JSON.parse(el.textContent); } catch (e) { return null; }
    var wanted = code.trim().toUpperCase();
    var match = rules.filter(function (r) {
      return String(r.code || '').trim().toUpperCase() === wanted;
    })[0];
    return match ? parsePromoRule(match) : null;
  }

  function promoDiscount(promo, subtotal) {
    if (!promo) return 0;
    var value = promo.percent ? Math.round(subtotal * promo.amount / 100) : promo.amount;
    return Math.max(0, Math.min(value, subtotal));
  }

  function setPromoMessage(form, message, isError) {
    var el = qs('[data-cod-promo-message]', form);
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    el.classList.toggle('is-error', Boolean(message) && isError);
    el.classList.toggle('is-success', Boolean(message) && !isError);
  }

  function clearCodPromo(form, message) {
    form.codPromo = null;
    var input = qs('[data-cod-promo-input]', form);
    var applyBtn = qs('[data-cod-promo-apply]', form);
    if (input) input.readOnly = false;
    if (applyBtn) {
      applyBtn.textContent = applyBtn.getAttribute('data-apply-label');
      applyBtn.classList.remove('is-applied');
    }
    setPromoMessage(form, message || '', true);
  }

  /* The single place order amounts are worked out, so the summary on screen
     and the payload sent to the endpoint can never drift apart. */
  function codTotals(root) {
    var form = qs('[data-cod-form]', root);
    var selection = codSelection(root);
    if (!form || !selection) return null;

    var subtotal = selection.variant.price * selection.quantity;
    var promo = form.codPromo || null;

    /* A quantity or variant change can drop the order under a code's
       minimum — release the code rather than honour it silently. */
    if (promo && promo.min && subtotal < promo.min) {
      var template = form.getAttribute('data-msg-promo-min') || '';
      clearCodPromo(form, template.replace('%amount%', formatMoney(promo.min, form.getAttribute('data-money-format'))));
      promo = null;
    }

    var discount = promoDiscount(promo, subtotal);
    return {
      form: form,
      variant: selection.variant,
      quantity: selection.quantity,
      subtotal: subtotal,
      promo: promo,
      discount: discount,
      total: subtotal - discount
    };
  }

  function refreshCodSummary(root) {
    var summary = qs('[data-cod-summary]', root);
    if (!summary) return;
    var totals = codTotals(root);
    if (!totals) return;

    var moneyFormat = totals.form.getAttribute('data-money-format');
    var title = totals.form.getAttribute('data-product-title') || '';
    var item = qs('[data-cod-summary-item]', summary);
    var qty = qs('[data-cod-summary-qty]', summary);
    var subtotalRow = qs('[data-cod-summary-subtotal]', summary);
    var discountRow = qs('[data-cod-summary-discount]', summary);
    var total = qs('[data-cod-summary-total]', summary);

    if (item) item.textContent = totals.variant.title && totals.variant.title !== 'Default Title'
      ? title + ' \u2014 ' + totals.variant.title
      : title;
    if (qty) qty.textContent = '\u00d7\u00a0' + totals.quantity;

    /* Subtotal only earns a line of its own once a discount sits under it. */
    if (subtotalRow) {
      subtotalRow.hidden = !totals.discount;
      var subtotalAmount = qs('[data-cod-summary-subtotal-amount]', subtotalRow);
      if (subtotalAmount) subtotalAmount.innerHTML = formatMoney(totals.subtotal, moneyFormat);
    }
    if (discountRow) {
      discountRow.hidden = !totals.discount;
      var label = qs('[data-cod-summary-discount-label]', discountRow);
      var amount = qs('[data-cod-summary-discount-amount]', discountRow);
      if (label && totals.promo) label.textContent = label.textContent.split(' (')[0] + ' (' + totals.promo.code + ')';
      if (amount) amount.innerHTML = '\u2212\u00a0' + formatMoney(totals.discount, moneyFormat);
    }
    if (total) total.innerHTML = formatMoney(totals.total, moneyFormat);
  }

  function refreshAllCodSummaries() {
    qsa('[data-cod-form-wrap]').forEach(function (wrap) {
      refreshCodSummary(wrap.closest('[data-product-root]') || document);
    });
  }

  /* The variant picker assigns select.value directly without firing an
     event, so the click is what we listen for; this handler is registered
     after it and therefore sees the updated selection. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-option-value]') || e.target.closest('[data-quantity-change]')) refreshAllCodSummaries();
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-quantity-selector]')) refreshAllCodSummaries();
  });

  function setCodFieldError(form, name, message) {
    var el = qs('[data-cod-error="' + name + '"]', form);
    var input = qs('[data-cod-field="' + name + '"]', form);
    if (el) {
      el.textContent = message || '';
      el.hidden = !message;
    }
    if (input) {
      input.classList.toggle('field--error', Boolean(message));
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }
  }

  function validateCodForm(form) {
    var firstInvalid = null;
    qsa('[data-cod-field]', form).forEach(function (input) {
      var name = input.getAttribute('data-cod-field');
      var value = (input.value || '').trim();
      var message = '';

      if (input.required && !value) {
        message = form.getAttribute('data-msg-required');
      } else if (name === 'phone' && value && value.replace(/\D/g, '').length < parseInt(form.getAttribute('data-phone-min') || '8', 10)) {
        message = form.getAttribute('data-msg-phone');
      } else if (name === 'email' && value && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
        message = form.getAttribute('data-msg-email');
      }

      setCodFieldError(form, name, message);
      if (message && !firstInvalid) firstInvalid = input;
    });

    if (firstInvalid) firstInvalid.focus();
    return !firstInvalid;
  }

  function codFieldValue(form, name) {
    var input = qs('[data-cod-field="' + name + '"]', form);
    return input ? input.value.trim() : '';
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cod-promo-toggle]');
    if (!toggle) return;
    var body = qs('[data-cod-promo-body]', toggle.parentNode);
    if (!body) return;
    var isHidden = body.hidden;
    body.hidden = !isHidden;
    toggle.setAttribute('aria-expanded', String(isHidden));
    if (isHidden) {
      var input = qs('[data-cod-promo-input]', body);
      if (input) input.focus();
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cod-promo-apply]');
    if (!btn) return;
    var form = btn.closest('[data-cod-form]');
    var input = qs('[data-cod-promo-input]', form);
    if (!form || !input) return;

    if (form.codPromo) {
      input.value = '';
      clearCodPromo(form, '');
      refreshAllCodSummaries();
      input.focus();
      return;
    }

    var code = input.value.trim();
    if (!code) { setPromoMessage(form, form.getAttribute('data-msg-promo-empty'), true); return; }

    var promo = findPromoRule(form, code);
    if (!promo) { setPromoMessage(form, form.getAttribute('data-msg-promo-invalid'), true); return; }

    var root = form.closest('[data-product-root]') || document;
    var moneyFormat = form.getAttribute('data-money-format');
    var selection = codSelection(root);
    var subtotal = selection ? selection.variant.price * selection.quantity : 0;

    if (promo.min && subtotal < promo.min) {
      setPromoMessage(form, (form.getAttribute('data-msg-promo-min') || '').replace('%amount%', formatMoney(promo.min, moneyFormat)), true);
      return;
    }

    form.codPromo = promo;
    input.value = promo.code;
    input.readOnly = true;
    btn.textContent = btn.getAttribute('data-remove-label');
    btn.classList.add('is-applied');
    setPromoMessage(form, (form.getAttribute('data-msg-promo-applied') || '')
      .replace('%code%', promo.code)
      .replace('%amount%', formatMoney(promoDiscount(promo, subtotal), moneyFormat)), false);
    refreshAllCodSummaries();
  });

  /* Enter inside the code field applies the code instead of submitting the
     whole order. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-cod-promo-input]');
    if (!input) return;
    e.preventDefault();
    var btn = qs('[data-cod-promo-apply]', input.closest('[data-cod-promo]'));
    if (btn) btn.click();
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-cod-field]');
    if (!input) return;
    var form = input.closest('[data-cod-form]');
    if (form) setCodFieldError(form, input.getAttribute('data-cod-field'), '');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cod-form]');
    if (!form) return;
    e.preventDefault();

    var errorEl = qs('[data-cod-message-error]', form);
    var successEl = qs('[data-cod-message-success]', form.parentNode);
    var submitBtn = qs('[data-cod-submit]', form);
    var spinner = submitBtn && qs('.spinner', submitBtn);
    if (errorEl) errorEl.hidden = true;

    /* Honeypot: a filled hidden field means a bot. Pretend it worked. */
    var honeypot = qs('.cod-form__hp input', form);
    if (honeypot && honeypot.value) { form.hidden = true; if (successEl) successEl.hidden = false; return; }

    if (!validateCodForm(form)) return;

    var endpoint = form.getAttribute('data-endpoint');
    if (!endpoint) {
      if (errorEl) { errorEl.textContent = form.getAttribute('data-msg-submit'); errorEl.hidden = false; }
      return;
    }

    var root = form.closest('[data-product-root]') || document;
    var moneyFormat = form.getAttribute('data-money-format');
    var totals = codTotals(root);
    var money = function (cents) { return cents === null || cents === undefined ? null : formatMoney(cents, moneyFormat); };

    var payload = {
      order_type: 'cash_on_delivery',
      submitted_at: new Date().toISOString(),
      shop: form.getAttribute('data-shop'),
      locale: document.documentElement.lang || '',
      page_url: window.location.href,
      product: {
        id: form.getAttribute('data-product-id'),
        title: form.getAttribute('data-product-title'),
        url: form.getAttribute('data-product-url'),
        variant_id: totals ? totals.variant.id : null,
        variant_title: totals ? totals.variant.title : null,
        sku: totals ? totals.variant.sku : null,
        quantity: totals ? totals.quantity : 1,
        currency: form.getAttribute('data-currency'),
        unit_price: totals ? totals.variant.price : null,
        unit_price_formatted: totals ? money(totals.variant.price) : null,
        subtotal_price: totals ? totals.subtotal : null,
        subtotal_price_formatted: totals ? money(totals.subtotal) : null,
        discount_amount: totals ? totals.discount : 0,
        discount_amount_formatted: totals ? money(totals.discount) : null,
        total_price: totals ? totals.total : null,
        total_price_formatted: totals ? money(totals.total) : null
      },
      discount: totals && totals.promo ? {
        code: totals.promo.code,
        rule: totals.promo.rule,
        amount: totals.discount,
        amount_formatted: money(totals.discount)
      } : null,
      customer: {
        name: codFieldValue(form, 'name'),
        phone: codFieldValue(form, 'phone'),
        email: codFieldValue(form, 'email'),
        address: codFieldValue(form, 'address'),
        city: codFieldValue(form, 'city'),
        note: codFieldValue(form, 'note')
      }
    };

    var blind = form.getAttribute('data-mode') === 'no-cors';
    var options = {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    };
    if (blind) options.mode = 'no-cors';

    if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }
    if (spinner) spinner.hidden = false;

    fetch(endpoint, options)
      .then(function (res) {
        if (!blind && !res.ok) throw new Error('Request failed with status ' + res.status);
        var redirect = form.getAttribute('data-redirect');
        if (redirect) { window.location.href = redirect; return; }
        form.hidden = true;
        if (successEl) {
          successEl.hidden = false;
          successEl.setAttribute('tabindex', '-1');
          successEl.focus();
          successEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = form.getAttribute('data-msg-submit'); errorEl.hidden = false; }
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
        if (spinner) spinner.hidden = true;
      });
  });

  /* ---------------------------------------------------------------------
     Product recommendations.
     `recommendations` only populates when a section is requested through
     Shopify's dedicated recommendations endpoint, so the section renders
     empty on a normal page load and is filled in here right after.
     ------------------------------------------------------------------- */
  function initRecommendations() {
    qsa('[data-recommendations-url]').forEach(function (el) {
      var url = el.getAttribute('data-recommendations-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-recommendations-url]');
          if (content && content.innerHTML.trim()) {
            el.innerHTML = content.innerHTML;
            initScrollReveal();
          }
        })
        .catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------
     Scroll-reveal animations. Elements opt in with [data-animate]; see
     the matching rules in base.css. Skipped entirely for users who
     prefer reduced motion — content just appears, already visible.
     ------------------------------------------------------------------- */
  var reduceMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var revealObserver = null;

  function initScrollReveal() {
    var items = qsa('[data-animate]:not(.is-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || (reduceMotionQuery && reduceMotionQuery.matches)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    }
    items.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------------------------------------------------------------------------
     Search popup: the header search link opens [data-search-modal] (<dialog>).
     Live results = sections/predictive-search.liquid via /search/suggest.
     Open/close/results animations use GSAP, loaded lazily (idle time, or first
     hover/focus/touch of the search icon). If GSAP isn't there yet, or the
     visitor prefers reduced motion, CSS handles a simple fade instead.
     Without JS (or <dialog> support) the link still goes to /search.
  --------------------------------------------------------------------------- */
  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.13.0/gsap.min.js';
  var gsapLoading = null;

  function loadGsap() {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (gsapLoading) return gsapLoading;
    gsapLoading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = GSAP_SRC;
      script.async = true;
      script.onload = function () {
        document.documentElement.classList.add('has-gsap');
        resolve(window.gsap);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
    gsapLoading.catch(function () { gsapLoading = null; });
    return gsapLoading;
  }

  function initSearchModal() {
    var modal = qs('[data-search-modal]');
    if (!modal || typeof modal.showModal !== 'function') return;
    var input = qs('input[name="q"]', modal);
    var results = qs('[data-search-results]', modal);
    var overlay = qs('[data-search-overlay]', modal);
    var panel = qs('.search-modal__panel', modal);
    var timer = null;
    var controller = null;
    var tl = null;
    var closing = false;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function motion() { return !reduceMotion && window.gsap ? window.gsap : null; }

    function resetStyles(gsap) {
      gsap.set([overlay, panel].concat(qsa('.search-modal__form > *, .search-modal__label, .search-modal__chip, .search-modal__results *', modal)), { clearProps: 'all' });
    }

    function open() {
      if (modal.open) return;
      closing = false;
      modal.showModal();
      document.documentElement.classList.add('search-open');
      window.setTimeout(function () { input.focus({ preventScroll: true }); input.select(); }, 30);

      var gsap = motion();
      if (!gsap) return;
      if (tl) tl.kill();
      resetStyles(gsap);
      var chips = qsa('.search-modal__chip', modal);
      var icon = qs('.search-modal__icon', modal);

      tl = gsap.timeline({ defaults: { ease: 'power3.out' } })
        // Blurred veil fades in
        .fromTo(overlay, { opacity: 0 }, { opacity: 1, duration: 0.4 }, 0)
        // Panel unfolds from the top: 3D tilt + clip reveal + slight overshoot
        .fromTo(panel,
          { opacity: 0, y: -48, scale: 0.9, rotationX: -18, clipPath: 'inset(0% 0% 100% 0% round 20px)' },
          { opacity: 1, y: 0, scale: 1, rotationX: 0, clipPath: 'inset(0% 0% 0% 0% round 20px)', duration: 0.8, ease: 'expo.out' }, 0.02)
        // Search field slides in, magnifier spins into place
        .fromTo(qsa('.search-modal__form > :not([type="hidden"]):not(label)', modal),
          { opacity: 0, x: -22 }, { opacity: 1, x: 0, duration: 0.5, stagger: 0.07 }, 0.2)
        .fromTo(icon, { rotation: -120, scale: 0.4 }, { rotation: 0, scale: 1, duration: 0.7, ease: 'back.out(2.5)' }, 0.22)
        .fromTo(qsa('.search-modal__label', modal), { opacity: 0, y: 10, letterSpacing: '0.3em' },
          { opacity: 0.6, y: 0, letterSpacing: '0.08em', duration: 0.5 }, 0.3)
        // Keyword chips pop in one by one, each from a random tilt
        .fromTo(chips,
          { opacity: 0, y: 24, scale: 0.5, rotation: function () { return gsap.utils.random(-16, 16); } },
          { opacity: 1, y: 0, scale: 1, rotation: 0, duration: 0.7, ease: 'elastic.out(1, 0.55)', stagger: 0.05 }, 0.36);
    }

    function close() {
      if (!modal.open || closing) return;
      var gsap = motion();
      if (!gsap) { modal.close(); return; }
      closing = true;
      if (tl) tl.kill();

      tl = gsap.timeline({
        onComplete: function () {
          modal.close();
          resetStyles(gsap);
          closing = false;
        }
      })
        // Chips and results scatter out, last in first out
        .to(qsa('.search-modal__chip', modal), {
          opacity: 0, y: -14, scale: 0.7,
          rotation: function () { return gsap.utils.random(-20, 20); },
          duration: 0.22, ease: 'power2.in', stagger: { each: 0.02, from: 'end' }
        }, 0)
        .to(qsa('.search-modal__results > *', modal), { opacity: 0, x: 18, duration: 0.2, ease: 'power2.in', stagger: 0.03 }, 0)
        // Panel folds back up and away
        .to(panel, {
          opacity: 0, y: -32, scale: 0.94, rotationX: 14,
          clipPath: 'inset(0% 0% 100% 0% round 20px)',
          duration: 0.5, ease: 'power4.inOut'
        }, 0.08)
        .to(overlay, { opacity: 0, duration: 0.35, ease: 'power2.out' }, 0.25);
    }

    function animateResults() {
      var gsap = motion();
      if (!gsap) return;
      gsap.fromTo(qsa('.search-modal__item, .search-modal__all, .search-modal__empty', results),
        { opacity: 0, y: 16, filter: 'blur(6px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.45, ease: 'power3.out', stagger: 0.05, delay: 0.05, clearProps: 'all' });
      gsap.fromTo(qsa('.search-modal__label', results), { opacity: 0, x: -10 }, { opacity: 0.6, x: 0, duration: 0.4, ease: 'power3.out' });
      gsap.fromTo(qsa('.search-modal__thumb img', results),
        { scale: 1.35 }, { scale: 1, duration: 0.8, ease: 'power3.out', stagger: 0.05 });
    }

    function run() {
      var q = input.value.trim();
      if (controller) controller.abort();
      if (!q) {
        results.innerHTML = '';
        modal.classList.remove('has-query');
        return;
      }
      modal.classList.add('has-query', 'is-loading');
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          results.innerHTML = section ? section.innerHTML : '';
          modal.classList.remove('is-loading');
          animateResults();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          modal.classList.remove('is-loading');
        });
    }

    // Warm GSAP up before the first click
    function warm(e) {
      if (e.target.closest && e.target.closest('[data-search-open]')) loadGsap().catch(function () {});
    }
    document.addEventListener('pointerover', warm, { passive: true });
    document.addEventListener('touchstart', warm, { passive: true });
    document.addEventListener('focusin', warm);
    if (!reduceMotion) {
      var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 2500); };
      window.addEventListener('load', function () { idle(function () { loadGsap().catch(function () {}); }); });
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-search-open]');
      if (!opener) return;
      e.preventDefault();
      open();
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-overlay]') || e.target === modal || e.target.closest('[data-search-close]')) {
        close();
        return;
      }
      var chip = e.target.closest('[data-search-keyword]');
      if (chip) {
        e.preventDefault();
        input.value = chip.getAttribute('data-search-keyword');
        var gsap = motion();
        if (gsap) gsap.fromTo(chip, { scale: 0.85 }, { scale: 1, duration: 0.6, ease: 'elastic.out(1.2, 0.4)' });
        run();
        input.focus({ preventScroll: true });
      }
    });

    // Esc: play the closing animation instead of closing instantly
    modal.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('search-open');
    });

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(run, 250);
    });
  }

  /* ---------------------------------------------------------------------------
     Search results page (sections/main-search.liquid). The intro is CSS; this
     adds the clear button and, with GSAP (loaded on first pointer move, desktop
     only), magnetic chips/submit, blob parallax and a 3D tilt on result cards.
  --------------------------------------------------------------------------- */
  function initSearchPage() {
    var page = qs('[data-search-page]');
    if (!page) return;
    var input = qs('[data-search-page-input]', page);
    var clear = qs('[data-search-page-clear]', page);

    if (input && clear) {
      input.addEventListener('input', function () { clear.hidden = input.value === ''; });
      clear.addEventListener('click', function () {
        input.value = '';
        clear.hidden = true;
        input.focus();
      });
    }

    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!finePointer || reduceMotion) return;

    // CSS intro animations (fill-mode both) would override GSAP's inline transforms
    qsa('.search-page__chip', page).forEach(function (el) {
      el.addEventListener('animationend', function () { el.style.animation = 'none'; }, { once: true });
    });

    function start(gsap) {
      // Magnetic: element leans toward the cursor, springs back on leave
      qsa('.search-page__chip, .search-page__submit', page).forEach(function (el) {
        var x = gsap.quickTo(el, 'x', { duration: 0.4, ease: 'power3.out' });
        var y = gsap.quickTo(el, 'y', { duration: 0.4, ease: 'power3.out' });
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect();
          x((e.clientX - r.left - r.width / 2) * 0.35);
          y((e.clientY - r.top - r.height / 2) * 0.45);
        });
        el.addEventListener('pointerleave', function () {
          gsap.to(el, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.4)' });
        });
      });

      // Blobs drift with the cursor
      var hero = qs('.search-page__hero', page);
      var blobs = qsa('.search-page__blob', page);
      if (hero && blobs.length) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          var dx = (e.clientX - r.left) / r.width - 0.5;
          var dy = (e.clientY - r.top) / r.height - 0.5;
          blobs.forEach(function (b, i) {
            var depth = i === 0 ? 60 : -45;
            gsap.to(b, { xPercent: dx * depth * 0.4, yPercent: dy * depth * 0.4, duration: 1.2, ease: 'power2.out', overwrite: 'auto' });
          });
        });
      }

      // Result card images tilt in 3D toward the cursor (the card itself keeps
      // its scroll-reveal CSS transition, so the media is animated instead)
      qsa('.search-page__body .product-card', page).forEach(function (card) {
        var media = qs('.product-card__media', card);
        if (!media) return;
        gsap.set(media, { transformPerspective: 900 });
        card.addEventListener('pointermove', function (e) {
          var r = media.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          gsap.to(media, { rotationY: px * 10, rotationX: -py * 10, y: -6, duration: 0.5, ease: 'power2.out', overwrite: 'auto' });
        });
        card.addEventListener('pointerleave', function () {
          gsap.to(media, { rotationY: 0, rotationX: 0, y: 0, duration: 0.8, ease: 'elastic.out(1, 0.5)', overwrite: 'auto' });
        });
      });
    }

    function boot() {
      document.removeEventListener('pointermove', boot);
      loadGsap().then(start).catch(function () {});
    }
    document.addEventListener('pointermove', boot, { passive: true });
  }

  /* ---------------------------------------------------------------------------
     Drawer extras (sections/cart-drawer.liquid): note / promo code / delivery
     tabs, order note saved to the cart, "Vous aimerez aussi" carousel dots.
     The drawer is re-rendered after each cart change, so state is re-applied
     on cart:updated.
  --------------------------------------------------------------------------- */
  var openDrawerTool = null;
  var cartNoteTimer = null;

  function applyDrawerTool(root) {
    qsa('[data-drawer-tool]', root).forEach(function (btn) {
      var on = btn.getAttribute('data-drawer-tool') === openDrawerTool;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-expanded', String(on));
    });
    qsa('[data-drawer-pane]', root).forEach(function (pane) {
      pane.hidden = pane.getAttribute('data-drawer-pane') !== openDrawerTool;
    });
  }

  function initDrawerCarousels(root) {
    qsa('[data-drawer-carousel]', root).forEach(function (carousel) {
      var track = qs('[data-carousel-track]', carousel);
      var dotsWrap = qs('[data-carousel-dots]', carousel);
      if (!track || !dotsWrap || carousel._ready) return;
      carousel._ready = true;
      var slides = qsa('[data-carousel-slide]', track);
      dotsWrap.innerHTML = '';
      if (slides.length < 2) return;
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.tabIndex = -1;
        dot.addEventListener('click', function () {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
      var dots = qsa('button', dotsWrap);
      function update() {
        var width = track.clientWidth || 1;
        var idx = Math.round(Math.abs(track.scrollLeft) / width);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === Math.min(idx, dots.length - 1)); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  document.addEventListener('click', function (e) {
    var tool = e.target.closest('[data-drawer-tool]');
    if (!tool) return;
    var name = tool.getAttribute('data-drawer-tool');
    openDrawerTool = openDrawerTool === name ? null : name;
    var root = tool.closest('.gf-drawer') || document;
    applyDrawerTool(root);
    var pane = openDrawerTool && qs('[data-drawer-pane="' + openDrawerTool + '"]', root);
    var field = pane && qs('input, textarea', pane);
    if (field) field.focus({ preventScroll: true });
  });

  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    window.clearTimeout(cartNoteTimer);
    cartNoteTimer = window.setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 500);
  });

  document.addEventListener('cart:updated', function () {
    applyDrawerTool(document);
    initDrawerCarousels(document);
  });

  /* ---------------------------------------------------------------------------
     EasySell COD button inside the cart drawer. The app injects
     #es-popup-button with inline !important styles (CSS can't override them),
     and after a drawer re-render it can land in the wrong form (upsell cards).
     Each time it appears: keep a single one, inside the checkout form, strip its
     inline styles, give it the theme pill classes and swap the icon.
     The element itself is kept, so EasySell's click handler still works.
  --------------------------------------------------------------------------- */
  var easySellQueued = false;

  function normalizeEasySellButtons() {
    easySellQueued = false;
    normalizeEasySellForm();
    qsa('.gf-drawer').forEach(function (drawer) {
      var buttons = qsa('.es-popup-button', drawer);
      if (!buttons.length) return;
      var checkoutForm = qs('.gf-drawer__checkout-form', drawer);
      if (!checkoutForm) {
        buttons.forEach(function (b) { b.remove(); });
        return;
      }
      var main = buttons.filter(function (b) { return checkoutForm.contains(b); })[0] || buttons[0];
      buttons.forEach(function (b) { if (b !== main) b.remove(); });
      if (!checkoutForm.contains(main)) checkoutForm.insertBefore(main, checkoutForm.firstChild);

      if (main.getAttribute('data-gf-styled') !== '1' || main.hasAttribute('style')) {
        main.removeAttribute('style');
        main.classList.add('gf-drawer__btn', 'gf-drawer__btn--dark', 'gf-drawer__es-btn');
        qsa('[style]', main).forEach(function (el) { el.removeAttribute('style'); });
        var legacyIcon = qs('i.bi', main);
        if (legacyIcon) {
          var holder = document.createElement('span');
          holder.innerHTML = iconSvg('shopping_bag', 'icon--sm');
          legacyIcon.replaceWith(holder.firstChild);
        }
        main.setAttribute('data-gf-styled', '1');
      }
    });

    // Product page buy card: same pill as the drawer, pink with a "cash on delivery" hint.
    qsa('[data-pdp-buy] .es-popup-button').forEach(function (btn) {
      if (btn.getAttribute('data-gf-styled') === '1' && !btn.hasAttribute('style')) return;
      btn.removeAttribute('style');
      qsa('[style]', btn).forEach(function (el) { el.removeAttribute('style'); });
      btn.classList.add('gf-drawer__btn', 'pdp-cod-btn');
      var legacyIcon = qs('i.bi', btn);
      if (legacyIcon) {
        var icon = document.createElement('span');
        icon.className = 'pdp-cod-btn__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
        (legacyIcon.parentElement && legacyIcon.parentElement !== btn ? legacyIcon.parentElement : legacyIcon).replaceWith(icon);
      }
      var buyCard = btn.closest('[data-pdp-buy]');
      var sub = buyCard && buyCard.getAttribute('data-text-cod');
      if (sub && !qs('.pdp-cod-btn__sub', btn)) {
        var subEl = document.createElement('span');
        subEl.className = 'pdp-cod-btn__sub';
        subEl.textContent = sub;
        btn.appendChild(subEl);
      }
      btn.setAttribute('data-gf-styled', '1');
    });
  }

  // COD form (#easysell-modal): the container and the submit button carry inline
  // !important colors/radius from the app settings; drop them so base.css applies.
  function normalizeEasySellForm() {
    qsa('#es-form-container[style], #es-form-button[style], #es-form-button .es-button-content [style]').forEach(function (el) {
      el.removeAttribute('style');
    });
    var cta = qs('#es-form-button');
    if (cta) cta.classList.add('gf-es-cta');
  }

  function queueEasySellNormalize() {
    if (easySellQueued) return;
    easySellQueued = true;
    window.requestAnimationFrame(normalizeEasySellButtons);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          var target = m.target;
          if (target.hasAttribute && target.hasAttribute('style') && target.classList &&
              (target.classList.contains('es-popup-button') || target.id === 'es-form-container' || target.id === 'es-form-button' || (target.closest && target.closest('#es-form-button')))) {
            queueEasySellNormalize();
            return;
          }
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList.contains('es-popup-button') || node.classList.contains('gf-drawer') || node.id === 'es-form-container' || qs('.es-popup-button, #es-form-container, #es-form-button', node)) {
            queueEasySellNormalize();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  /* ---------------------------------------------------------------------------
     Product share (snippets/product-share.liquid).
     Toggle bursts the network buttons out (GSAP when loaded, CSS otherwise),
     copy link swaps the icon + pops a toast, "Plus" opens the native share
     sheet (only shown where navigator.share exists). Social links open in a
     small popup window on desktop.
  --------------------------------------------------------------------------- */
  function initProductShare() {
    qsa('[data-product-share]').forEach(function (root) {
      if (root._shareReady) return;
      root._shareReady = true;
      root.classList.add('js-share');
      var toggle = qs('[data-share-toggle]', root);
      var panel = qs('[data-share-panel]', root);
      var toast = qs('[data-share-toast]', root);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var tl = null;
      var toastTimer = null;
      var url = root.getAttribute('data-share-url');

      if (navigator.share) {
        var nativeItem = qs('[data-share-native-item]', root);
        if (nativeItem) nativeItem.hidden = false;
      }

      // Load GSAP early so the first open is animated
      loadGsap().catch(function () {});

      function items() { return qsa('.product-share__list > li:not([hidden]) .product-share__item', root); }

      function open() {
        if (root.classList.contains('is-open')) return;
        root.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        var gsap = !reduce && window.gsap;
        if (!gsap) return;
        if (tl) tl.kill();
        var list = items();
        tl = gsap.timeline()
          .fromTo(qs('.product-share__toggle-icon', root), { rotation: 0 }, { rotation: 360, duration: 0.6, ease: 'back.out(2)' }, 0)
          .fromTo(panel, { height: 0 }, { height: 'auto', duration: 0.45, ease: 'power3.out' }, 0)
          .fromTo(list,
            { opacity: 0, scale: 0.2, y: -26, x: function (i) { return -18 * (i + 1); }, rotation: function () { return gsap.utils.random(-90, 90); } },
            { opacity: 1, scale: 1, y: 0, x: 0, rotation: 0, duration: 0.75, ease: 'elastic.out(1, 0.55)', stagger: 0.05, clearProps: 'transform' }, 0.05)
          .fromTo(list, { boxShadow: '0 0 0 0 rgba(224, 69, 123, 0.45)' },
            { boxShadow: '0 0 0 12px rgba(224, 69, 123, 0)', duration: 0.7, ease: 'power2.out', stagger: 0.05, clearProps: 'boxShadow' }, 0.25);
      }

      function close() {
        if (!root.classList.contains('is-open')) return;
        toggle.setAttribute('aria-expanded', 'false');
        var gsap = !reduce && window.gsap;
        if (!gsap) { root.classList.remove('is-open'); return; }
        if (tl) tl.kill();
        tl = gsap.timeline({
          onComplete: function () {
            root.classList.remove('is-open');
            gsap.set([panel].concat(items()), { clearProps: 'all' });
          }
        })
          .to(items().reverse(), { opacity: 0, scale: 0.3, y: -14, rotation: function () { return gsap.utils.random(-45, 45); }, duration: 0.25, ease: 'power2.in', stagger: 0.025 }, 0)
          .to(panel, { height: 0, duration: 0.3, ease: 'power3.inOut' }, 0.15)
          .to(qs('.product-share__toggle-icon', root), { rotation: 0, duration: 0.4, ease: 'power2.out' }, 0);
      }

      function showToast() {
        toast.hidden = false;
        var gsap = !reduce && window.gsap;
        window.clearTimeout(toastTimer);
        if (gsap) {
          gsap.fromTo(toast, { opacity: 0, y: 12, scale: 0.8 }, { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: 'back.out(2.5)' });
        }
        toastTimer = window.setTimeout(function () {
          if (gsap) {
            gsap.to(toast, { opacity: 0, y: -8, duration: 0.3, ease: 'power2.in', onComplete: function () { toast.hidden = true; gsap.set(toast, { clearProps: 'all' }); } });
          } else {
            toast.hidden = true;
          }
        }, 2200);
      }

      function copyLink(btn) {
        var done = function () {
          btn.classList.add('is-copied');
          var gsap = !reduce && window.gsap;
          if (gsap) gsap.fromTo(btn, { scale: 0.8 }, { scale: 1, duration: 0.6, ease: 'elastic.out(1.2, 0.4)' });
          showToast();
          window.setTimeout(function () { btn.classList.remove('is-copied'); }, 2200);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(done).catch(fallback);
        } else {
          fallback();
        }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          ta.remove();
        }
      }

      toggle.addEventListener('click', function () {
        if (root.classList.contains('is-open')) close(); else open();
      });

      root.addEventListener('click', function (e) {
        var copy = e.target.closest('[data-share-copy]');
        if (copy) { copyLink(copy); return; }

        var native = e.target.closest('[data-share-native]');
        if (native) {
          navigator.share({
            title: root.getAttribute('data-share-title'),
            text: root.getAttribute('data-share-text'),
            url: url
          }).catch(function () {});
          return;
        }

        var link = e.target.closest('[data-share-network]');
        if (!link) return;
        var network = link.getAttribute('data-share-network');
        var gsap = !reduce && window.gsap;
        if (gsap) gsap.fromTo(link, { scale: 0.85 }, { scale: 1, duration: 0.5, ease: 'elastic.out(1.2, 0.4)' });
        // Popup window on desktop for web share dialogs
        if (['facebook', 'x', 'telegram', 'pinterest'].indexOf(network) !== -1 && window.matchMedia('(min-width: 768px)').matches) {
          e.preventDefault();
          var w = 620;
          var h = 560;
          var left = Math.max(0, (window.screen.width - w) / 2);
          var top = Math.max(0, (window.screen.height - h) / 2);
          var popup = window.open(link.href, 'gf-share', 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top);
          if (popup) popup.opener = null;
          else window.open(link.href, '_blank', 'noopener');
        }
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  /* ---------------------------------------------------------------------------
     Product gallery (sections/main-product.liquid → [data-pg]).
     Slides are stacked; goTo() runs a direction-aware GSAP transition
     (incoming clip reveal + zoom settle, outgoing shrink/slide/blur), updates
     thumbnails, the rolling counter and the progress bar. Swipe, arrows and
     ← → keys navigate; the zoom layer follows the cursor on desktop.
     Without GSAP (or with reduced motion) slides cross-fade in CSS.
     el._pg.goToSrc(url) is used by the variant picker.
  --------------------------------------------------------------------------- */
  function initProductGallery() {
    qsa('[data-pg]').forEach(function (el) {
      if (el._pg) return;
      var slides = qsa('[data-pg-slide]', el);
      var thumbs = qsa('[data-pg-thumb]', el);
      var viewport = qs('[data-pg-viewport]', el);
      var counter = qs('[data-pg-current]', el);
      var progress = qs('[data-pg-progress]', el);
      var thumbsWrap = qs('[data-pg-thumbs]', el);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      var tl = null;

      if (slides.length < 2) { el._pg = { goTo: function () {}, goToSrc: function () {} }; return; }
      loadGsap().catch(function () {});

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function syncUi(index, animate) {
        thumbs.forEach(function (t, i) {
          var on = i === index;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', String(on));
        });
        slides.forEach(function (s, i) {
          if (i === index) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        if (progress) progress.style.transform = 'scaleX(' + ((index + 1) / slides.length) + ')';
        var gsap = animate && window.gsap;
        if (counter) {
          if (gsap) {
            gsap.to(counter, {
              yPercent: -110, duration: 0.25, ease: 'power2.in',
              onComplete: function () {
                counter.textContent = pad(index + 1);
                gsap.fromTo(counter, { yPercent: 110 }, { yPercent: 0, duration: 0.45, ease: 'power3.out' });
              }
            });
          } else {
            counter.textContent = pad(index + 1);
          }
        }
        var thumb = thumbs[index];
        if (thumb && thumbsWrap) {
          var left = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.offsetWidth) / 2;
          thumbsWrap.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
          if (gsap) gsap.fromTo(thumb, { scale: 0.86 }, { scale: 1, duration: 0.6, ease: 'elastic.out(1.1, 0.5)', clearProps: 'transform' });
        }
      }

      function goTo(index, dir) {
        index = (index + slides.length) % slides.length;
        if (index === current) return;
        var from = slides[current];
        var to = slides[index];
        if (!dir) dir = index > current ? 1 : -1;
        var visualDir = rtl ? -dir : dir;
        var gsap = !reduce && window.gsap;

        if (tl) tl.progress(1).kill();
        current = index;

        if (!gsap) {
          from.classList.remove('is-active');
          to.classList.add('is-active');
          syncUi(index, false);
          return;
        }

        var fromImg = qs('.pg-slide__zoom', from);
        var toImg = qs('.pg-slide__zoom', to);
        from.classList.add('is-leaving');
        to.classList.add('is-active');
        from.classList.remove('is-active');

        tl = gsap.timeline({
          onComplete: function () {
            from.classList.remove('is-leaving');
            gsap.set([from, to, fromImg, toImg], { clearProps: 'all' });
          }
        })
          .set(to, { zIndex: 3 })
          .set(from, { zIndex: 2 })
          .fromTo(to,
            { clipPath: visualDir > 0 ? 'inset(0% 0% 0% 100% round 22px)' : 'inset(0% 100% 0% 0% round 22px)' },
            { clipPath: 'inset(0% 0% 0% 0% round 22px)', duration: 0.95, ease: 'expo.inOut' }, 0)
          .fromTo(toImg,
            { scale: 1.35, xPercent: 14 * visualDir, rotation: 3 * visualDir },
            { scale: 1, xPercent: 0, rotation: 0, duration: 1.15, ease: 'expo.out' }, 0.1)
          .to(fromImg,
            { scale: 0.86, xPercent: -20 * visualDir, rotation: -2 * visualDir, filter: 'blur(8px) brightness(0.65)', duration: 0.95, ease: 'expo.inOut' }, 0);

        syncUi(index, true);
      }

      function goToSrc(src) {
        var key = String(src).split('?')[0].split('/').pop();
        var idx = slides.findIndex(function (s) {
          var k = s.getAttribute('data-src-key') || '';
          // image_url adds size suffixes; compare the base file name
          return k && (key.indexOf(k.replace(/\.[^.]+$/, '')) === 0 || k === key);
        });
        if (idx !== -1) goTo(idx);
      }

      el.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-pg-thumb]');
        if (thumb) { goTo(parseInt(thumb.getAttribute('data-pg-thumb'), 10)); return; }
        if (e.target.closest('[data-pg-prev]')) { goTo(current - 1, -1); return; }
        if (e.target.closest('[data-pg-next]')) { goTo(current + 1, 1); }
      });

      el.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var forward = e.key === 'ArrowRight' ? 1 : -1;
        if (rtl) forward = -forward;
        e.preventDefault();
        goTo(current + forward, forward);
      });

      // Swipe
      var startX = null;
      var startY = null;
      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' || e.target.closest('button')) return;
        startX = e.clientX;
        startY = e.clientY;
      });
      viewport.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
        var forward = dx < 0 ? 1 : -1;
        if (rtl) forward = -forward;
        goTo(current + forward, forward);
      });
      viewport.addEventListener('pointercancel', function () { startX = null; });

      // Cursor-follow zoom on desktop
      if (!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        viewport.addEventListener('pointermove', function (e) {
          var gsap = window.gsap;
          if (!gsap) return;
          var r = viewport.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          var img = qs('.pg-slide.is-active img', viewport);
          if (img) gsap.to(img, { scale: 1.08, xPercent: -px * 5, yPercent: -py * 5, duration: 0.8, ease: 'power3.out', overwrite: 'auto' });
        });
        viewport.addEventListener('pointerleave', function () {
          var gsap = window.gsap;
          if (!gsap) return;
          qsa('.pg-slide img', viewport).forEach(function (img) {
            gsap.to(img, { scale: 1, xPercent: 0, yPercent: 0, duration: 0.9, ease: 'power3.out', overwrite: 'auto' });
          });
        });
      }

      syncUi(current, false);
      el._pg = { goTo: goTo, goToSrc: goToSrc };
    });
  }

  /* ---------------------------------------------------------------------------
     FAQ page (sections/main-faq.liquid).
     Accordions animate their height (Web Animations API), one open at a time.
     Live search (accent-insensitive) filters questions + answers and highlights
     matches; category pills filter groups; the side nav tracks the group in view.
     "/" focuses the search; #faq-q-N in the URL opens that question.
  --------------------------------------------------------------------------- */
  function initFaqPage() {
    var page = qs('[data-faq-page]');
    if (!page) return;
    var items = qsa('[data-faq-item]', page);
    var groups = qsa('[data-faq-group]', page);
    var search = qs('[data-faq-search]', page);
    var clearBtn = qs('[data-faq-clear]', page);
    var empty = qs('[data-faq-empty]', page);
    var pills = qsa('[data-faq-filter]', page);
    var navLinks = qsa('[data-faq-nav]', page);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activeFilter = 'all';

    function normalize(str) {
      return String(str || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }
    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    items.forEach(function (item) {
      var q = qs('[data-faq-question]', item);
      item._question = q.textContent.trim();
      item._haystack = normalize(item._question + ' ' + qs('[data-faq-answer]', item).textContent);
    });

    // ---- Accordion
    function animateOpen(item) {
      var answer = qs('[data-faq-answer]', item);
      item.open = true;
      if (reduce || !answer.animate) return;
      var h = answer.scrollHeight;
      answer.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.16,1,.3,1)' });
      var inner = answer.firstElementChild;
      if (inner) inner.animate([{ transform: 'translateY(-8px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 450, delay: 60, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
    }
    function animateClose(item) {
      var answer = qs('[data-faq-answer]', item);
      if (reduce || !answer.animate) { item.open = false; return; }
      item.classList.add('is-closing');
      var h = answer.offsetHeight;
      var anim = answer.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)' });
      anim.onfinish = function () { item.open = false; item.classList.remove('is-closing'); };
    }

    items.forEach(function (item) {
      qs('summary', item).addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-closing')) return;
        if (item.open) {
          animateClose(item);
        } else {
          items.forEach(function (other) { if (other !== item && other.open) animateClose(other); });
          animateOpen(item);
          if (history.replaceState) history.replaceState(null, '', '#' + item.id);
        }
      });
    });

    // ---- Filtering (search + category)
    function highlight(item, terms) {
      var q = qs('[data-faq-question]', item);
      var text = item._question;
      if (!terms.length) { q.textContent = text; return; }
      var norm = normalize(text);
      var marks = [];
      terms.forEach(function (t) {
        var from = 0;
        var idx;
        while (t && (idx = norm.indexOf(t, from)) !== -1) { marks.push([idx, idx + t.length]); from = idx + t.length; }
      });
      if (!marks.length) { q.textContent = text; return; }
      marks.sort(function (a, b) { return a[0] - b[0]; });
      var html = '';
      var pos = 0;
      marks.forEach(function (m) {
        if (m[0] < pos) return;
        html += escapeHtml(text.slice(pos, m[0])) + '<mark>' + escapeHtml(text.slice(m[0], m[1])) + '</mark>';
        pos = m[1];
      });
      q.innerHTML = html + escapeHtml(text.slice(pos));
    }

    function applyFilters() {
      var raw = search ? search.value.trim() : '';
      var terms = normalize(raw).split(/\s+/).filter(function (t) { return t.length > 1; });
      var visibleTotal = 0;
      groups.forEach(function (group) {
        var inCategory = activeFilter === 'all' || group.getAttribute('data-faq-group') === activeFilter;
        var visibleInGroup = 0;
        qsa('[data-faq-item]', group).forEach(function (item) {
          var match = inCategory && terms.every(function (t) { return item._haystack.indexOf(t) !== -1; });
          item.hidden = !match;
          highlight(item, match ? terms : []);
          if (match) visibleInGroup++;
        });
        group.hidden = visibleInGroup === 0;
        visibleTotal += visibleInGroup;
      });
      if (empty) empty.hidden = visibleTotal > 0;
      if (clearBtn) clearBtn.hidden = raw === '';
      page.classList.toggle('is-searching', raw !== '');
      // Stagger the visible questions back in
      if (!reduce) {
        qsa('[data-faq-item]:not([hidden])', page).forEach(function (item, i) {
          if (item.animate) item.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 380, delay: Math.min(i, 10) * 30, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
        });
      }
    }

    var searchTimer = null;
    if (search) {
      search.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(applyFilters, 120);
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        search.value = '';
        applyFilters();
        search.focus();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || !search) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      e.preventDefault();
      search.focus();
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        activeFilter = pill.getAttribute('data-faq-filter');
        pills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-selected', String(on));
        });
        applyFilters();
        var target = activeFilter === 'all' ? qs('.faq-layout', page) : qs('#faq-' + activeFilter, page);
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 110;
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    });

    // ---- Side nav: smooth scroll + active group while scrolling
    navLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('data-faq-nav');
        var target = qs('#faq-' + id, page);
        if (!target) return;
        e.preventDefault();
        if (activeFilter !== 'all') {
          activeFilter = 'all';
          pills.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-faq-filter') === 'all'); });
          applyFilters();
        }
        var top = target.getBoundingClientRect().top + window.pageYOffset - 110;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if ('IntersectionObserver' in window && navLinks.length) {
      var navObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.getAttribute('data-faq-group');
          navLinks.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-faq-nav') === id); });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach(function (g) { navObserver.observe(g); });
    }

    // ---- Deep link
    if (/^#faq-q-\d+$/.test(window.location.hash)) {
      var linked = qs(window.location.hash, page);
      if (linked) {
        linked.open = true;
        linked.classList.add('is-highlighted');
        window.setTimeout(function () {
          var top = linked.getBoundingClientRect().top + window.pageYOffset - 130;
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        }, 200);
      }
    }
  }

  /* ---------------------------------------------------------------------------
     Mobile menu bottom sheet: drag the grab bar or header down to close.
  --------------------------------------------------------------------------- */
  function initMobileNav() {
    var nav = qs('#mobile-nav');
    var panel = nav && qs('[data-mobile-nav-panel]', nav);
    if (!panel) return;
    var handles = qsa('[data-mobile-nav-grab], [data-mobile-nav-drag]', nav);
    var startY = null;
    var delta = 0;

    handles.forEach(function (handle) {
      handle.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a, button')) return;
        startY = e.clientY;
        delta = 0;
        panel.classList.add('is-dragging');
        if (handle.setPointerCapture) handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointermove', function (e) {
        if (startY === null) return;
        delta = Math.max(0, e.clientY - startY);
        panel.style.transform = 'translateY(' + delta + 'px)';
      });
      function end() {
        if (startY === null) return;
        startY = null;
        panel.classList.remove('is-dragging');
        panel.style.transform = '';
        if (delta > Math.min(140, panel.offsetHeight * 0.25)) trapClose('#mobile-nav');
      }
      handle.addEventListener('pointerup', end);
      handle.addEventListener('pointercancel', end);
    });
  }

  /* ---------------------------------------------------------------------------
     Lazy videos (snippets/video-media.liquid, gf-lp-avis): <video data-lazy-video>
     with <source data-src>. Sources are attached ~300px before the video enters
     the viewport; autoplay videos play while visible and pause off-screen, so
     below-the-fold and carousel videos cost nothing on first load.
  --------------------------------------------------------------------------- */
  function initLazyVideos() {
    var videos = qsa('video[data-lazy-video]');
    if (!videos.length) return;

    function attach(video) {
      if (video._lazyLoaded) return;
      video._lazyLoaded = true;
      qsa('source[data-src]', video).forEach(function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });
      video.load();
    }

    function play(video) {
      if (!video.hasAttribute('data-autoplay')) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { attach(v); play(v); });
      return;
    }

    var loader = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        attach(entry.target);
        loader.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    var player = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          attach(video);
          play(video);
        } else if (!video.paused && video.hasAttribute('data-autoplay')) {
          video.pause();
        }
      });
    }, { threshold: 0.15 });

    function observe(v) {
      loader.observe(v);
      player.observe(v);
    }

    videos.forEach(function (v) {
      if (!v.hasAttribute('data-defer') || document.readyState === 'complete') {
        observe(v);
        return;
      }
      window.addEventListener('load', function () { setTimeout(function () { observe(v); }, 50); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLazyVideos();
    paintWishlistButtons();
    initMobileNav();
    initFaqPage();
    initProductGallery();
    initProductShare();
    normalizeEasySellButtons();
    initDrawerCarousels(document);
    initSearchModal();
    initSearchPage();
    refreshAllCodSummaries();
    initRecommendations();
    initScrollReveal();
  });
})();
